import React from 'react';
import StatusBanner from '../common/StatusBanner';
import { formatPhoneNumber } from "../../helpers/formatting";
import * as Tools from "../../helpers/Tools";
import StaticHtmlContent from "../common/staticHtmlContent";

const DFWCCHelpDeskNumber = "8007845473"; //will read from props

class AutoLinkErrorForHP extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (typeof window !== 'undefined' && Tools.isMobile()) {
            window.scrollTo(0, 0);
        }
    }
    render() {
        const locationState = this.props.location && this.props.location.state;
        const phoneNumber = formatPhoneNumber(locationState && locationState.at ? locationState.at : DFWCCHelpDeskNumber);
        const helpDeskHours = locationState && locationState.hdHours ? locationState.hdHours : "";
        const heading = locationState && locationState.heading ? locationState.heading : "";
        const msg = locationState && locationState.msg ? locationState.msg : "";
        const callTo = locationState && locationState.callTo;

        return (<div className="container-fluid body-content DFWCC-status-container">
            <div className="row">
                <div className="col-12">
                    {<StatusBanner bannerAlignment="left" bannerMsg={`We were unable to link your ${heading ? heading : 'account'}.`} failedStatus >
                        <span>
                            {msg ? <StaticHtmlContent content={msg} /> :
                                <span> For assistance, call the {callTo ? callTo : "DFW ConnectedCare Center"} {helpDeskHours && <>{helpDeskHours}{` `}</> }at {phoneNumber && <span>{" "}<a href={"tel:" + phoneNumber} className="phone-link">{phoneNumber}</a></span>}{callTo ? "" : " and press 1"}.</span>
                            }
                       </span>
                    </StatusBanner>}
                </div>
            </div>
        </div>);
    }
}

export default AutoLinkErrorForHP;